// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-widget .revico-community-talk .revico-community-talk-post-complete {\n  text-align: center;\n  white-space: pre-wrap;\n}\n.revico-widget .revico-community-talk .revico-community-talk-post-complete .fa-circle-check {\n  display: block;\n  margin: 0 auto 12px auto;\n  font-size: 3em;\n  opacity: 0.4;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
